export default "__VITE_ASSET__eb5u0r$E__"